<template>
  <div id="jjgk">
    <div class="tab">
      <a @click="tabindex=0" :class="{ active: tabindex===0}">概况</a>
      <a @click="tabindex=1" :class="{ active: tabindex===1}">信息</a>
      <a @click="tabindex=2" :class="{ active: tabindex===2}">投资经理</a>
    </div>
    <div v-show="tabindex===0">
      <div v-if="jjgk" class="wapper">
        <div class="title">
          <div class="i">i</div>
          {{jjgk.xx.name}}
        </div>
        <div>
          <div class="rz">基金类型：{{jjgk.xx.jjlx}}</div>
          <div class="rz">基金风格：{{jjgk.xx.jjfg}}</div>
          <div class="rz">单位净值：{{jjgk.gk[jjgk.gk.length - 1].dwjz}}</div>
          <div class="rz">累计净值：{{jjgk.gk[jjgk.gk.length - 1].ljjz}}</div>
          <div class="rz">累计年化：{{parseFloat(jjgk.gk[jjgk.gk.length - 1].ljnh).toFixed(2)}}%</div>
          <div class="rz">更新日期：{{jjgk.gk[jjgk.gk.length - 1].time}}</div>
        </div>
      </div>
      <div id="echarts"></div>
      <div class="charttitle">累计净值走势图</div>
    </div>
    <div v-show="tabindex===1" class="wapper">
      <div v-if="jjgk">
        <div class="title">
          <div class="i">i</div>
          {{jjgk.xx.name}}
        </div>
        <div class="rz">基金名称：{{jjgk.xx.name}}</div>
        <div class="rz">基金简称：{{jjgk.xx.jjjc}}</div>
        <div class="rz">基金类型：{{jjgk.xx.jjlx}}</div>
        <div class="rz">基金风格：{{jjgk.xx.jjfg}}</div>
        <div class="rz">成立日期：{{jjgk.xx.clrq}}</div>
        <div class="rz">管理机构：{{jjgk.xx.gljg}}</div>
        <div class="rz">托管机构：{{jjgk.xx.tgjg}}</div>
        <div class="rz">认购起点：{{jjgk.xx.rgqd}}</div>
        <div class="rz">投资策略：{{jjgk.xx.tzcl}}</div>
        <div class="rz">投资禁止：{{jjgk.xx.tzjz}}</div>
        <div class="rz">投资范围：{{jjgk.xx.tzfw}}</div>
        <div class="rz">基金特色：{{jjgk.xx.jjts}}</div>
      </div>
    </div>
    <div v-show="tabindex===2" class="wapper">
      <div v-if="jjgk">
        <div class="title">
          <div class="i">i</div>
          {{jjgk.xx.name}}
        </div>
        <div class="name">{{jjgk.jl.name}}</div>
        <div class="rz">任职时间：{{jjgk.jl.begin}}{{(jjgk.jl.end === '') ? '至今' : '-' + jjgk.jl.end }}</div>
        <div class="xq">{{jjgk.jl.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import List from '@/components/list/List'
  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'jjgk',
    data () {
      return {
        jjgk: false,
        tabindex: 0
      }
    },
    created: function () {
      ajax.getJjgk(this.$route.params.id).then(
        data => {
          this.jjgk = data
        }
      )
    },
    watch: {
      jjgk: function (newvalue) {
        let xAxis = []
        let series = []
        newvalue.gk.forEach(function (item) {
          xAxis.push(item.time)
          series.push({
            value: item.ljjz,
            item: item
          })
        })
        let option = {
          grid: [
            {x: '10%', y: '10%', width: '85%', height: '80%'}
          ],
          color: ['#4f6fc0'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              animation: false
            },
            formatter: function (params) {
              return '日期：' + params[0].data.item.time + '<br>' +
                '累积净值：' + parseFloat(params[0].data.item.ljjz).toFixed(4) + '<br>' +
                '单位净值：' + parseFloat(params[0].data.item.dwjz).toFixed(4) + '<br>' +
                '累积年化：' + parseFloat(params[0].data.item.ljnh).toFixed(2) + '%<br>'
            }
          },
          xAxis: {
            data: xAxis,
            splitArea: {
              interval: Math.floor(xAxis.length / 5),
              show: true,
              areaStyle: {color: ['rgba(255,255,255,0)', 'rgba(228,235,253,0.5)']}
            }
          },
          yAxis: {type: 'value'},
          series: [{
            name: '累积净值',
            type: 'line',
            data: series
          }]
        }
        // 基于准备好的dom，初始化echarts实例
        require.ensure(['echarts/lib/echarts'], function (require) {
          let echarts = require('echarts/lib/echarts')
          require('echarts/lib/chart/line')
          require('echarts/lib/component/tooltip')
          let myChart = echarts.init(document.getElementById('echarts'))
          // 绘制图表
          myChart.setOption(option)
        })
      }
    },
    components: {
      List
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../../common/stylus/common.styl"
  #echarts
    height 200px
    width 100%

  .charttitle
    text-align center
    margin-top 20px
    color $font_color5
    font-size 11px

  #zcgl
    #jjgk
        background-color: #fff

  #jjgk
    .tab
      padding 0 $bj 0 $bj
      background-color $color2
      font-size $font_size2
      color $font_color3
      height 40px
      line-height 40px
      text-align center
      a
        padding 0 15px 0 15px
        border-right solid 1px #a3b8ea
        &.active
          color $font_color2
        &:last-child
          border-right 0
    .wapper
      padding 0 $bj 20px $bj
      .title
        margin-left -15px
        padding-top 15px
        padding-bottom 16px
        color $font_color1
        font-size $font_size3
        line-height $font_size3
        font-weight bold
        .i
          width 6px
          height 15px
          color transparent
          background-color $color1
          margin-right 9px
          display inline-block

      .name
        font-weight bolder
        color $font_color1
        font-size 18px
      .xq
        margin-top 20px
        font-size $font_size4
      .rz
        font-size $font_size4
</style>



// WEBPACK FOOTER //
// jjgk.vue?763fd4ae